import $ from 'jquery';
import '../vendor/slick-carousel/slick.fix';

const defaults = {
  speed: 200,
  dots: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  slide: '.views-row',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '85px',
      },
    },
    {
      breakpoint: 380,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '75px',
      },
    },
    {
      breakpoint: 325,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '60px',
      },
    },
  ],
};

function StatsSlider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.slider = this.build();
  this.ready();
}

StatsSlider.prototype = {
  build() {
    return this.$element.find('.view-content').slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default StatsSlider;



// WEBPACK FOOTER //
// ./StatsSlider.js